/* 🤖 this file was generated by svg-to-ts */
export const kzIconsSort: {
  name: 'sort';
  data: string;
} = {
  name: 'sort',
  data: `<svg viewBox="0 0 16 16" xml:space="preserve" fill="currentColor" enable-background="new 0 0 16 16"><path d="m7.5 10.6-2.3 2.3V1.3c0-.4-.3-.8-.8-.8s-.7.4-.7.8v11.5l-2.3-2.3c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l3.6 3.6c.1.1.3.2.5.2s.4-.1.5-.2l3.6-3.6c.3-.3.3-.8 0-1.1s-.7-.2-1 .1zM15.6 4.4 12 .8c-.3-.3-.8-.3-1.1 0L7.5 4.4c-.3.3-.3.8 0 1.1s.8.3 1.1 0l2.3-2.3v11.5c0 .4.3.8.8.8s.8-.3.8-.8V3.1l2.3 2.3c.1.1.3.2.5.2s.4-.1.5-.2c.1-.3.1-.7-.2-1z"/></svg>`
};
